import React from 'react';
import { 
  Container, 
  
} from 'react-bootstrap';


const ReportsPanel = () => {

  

  return (
    <Container fluid>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Звіти</h2>
        
      </div>

      
    </Container>
  );
};

export default ReportsPanel;